import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import * as Views from './views'
import Layout from './Layout'
import { PATH, makePath } from 'config'

const propTypes = {}

function Routes() {
  const { path } = useRouteMatch()

  return (
    <Layout>
      <Switch>
        <Route exact path={makePath(path, PATH.ROOT)}>
          <Views.SavingsClubOffers />
        </Route>
        <Route path={makePath(path, PATH.NEW)}>
          <Views.NewOffer />
        </Route>
        <Route path={makePath(path, PATH.EDIT_OFFER)}>
          <Views.EditOffer />
        </Route>
        <Route path={makePath(path, PATH.CONFIRM_OFFER)}>
          <Views.ConfirmOffer />
        </Route>
      </Switch>
    </Layout>
  )
}

Routes.propTypes = propTypes

export default Routes
